export default __webpack_public_path__ + "static/media/technicalIndicator-ebook.eea4dbc1.png";